import { Component } from "react";

class ConfirmForm extends Component {
  onBeforeUnload(e) {
    //messages are deprecated but for old browsers will work
    let msg = "Changes you made might not be saved. Leave this page?";
    if (this.hasChanges) {
      e.returnValue = msg;
      return msg;
    }
  }

  unregisterUnloadPrompt(){
   window.removeEventListener('onbeforeunload', this.onBeforeUnload);
  }

  componentDidUpdate() {
    let { pristine, submitting, initialValues } = this.props;
    let disabled = pristine || submitting || initialValues.reverting;
    this.hasChanges = !disabled;

    window.onbeforeunload = this.onBeforeUnload;
  }
}

export default ConfirmForm;



// WEBPACK FOOTER //
// app/containers/ConfirmForm.jsx